import PropTypes from "prop-types";
import React from "react";
import { Icon, Typography } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import TableGrid from "../../waybee-ui/TableGrid";

const FallBackMessage = styled(Typography)`
  padding-top: 12px;
  margin: 0;
`;

export default function OccurrenceTableList({
  occurrences,
  primaryColor,
  dateLocale,
  onSelect,
  emptyMessage
}) {
  const { t } = useTranslation();

  if (occurrences.length === 0) {
    return <FallBackMessage>{emptyMessage}</FallBackMessage>;
  }

  return (
    <TableGrid>
      {occurrences.map(occur => {
        const [date, time] = new Date(occur.date)
          .toLocaleString(dateLocale)
          .split(",");
        return (
          <TableGrid.Row
            key={occur.id || `${occur.date}-${occur.reason}`}
            actionIcon
            button
            onClick={() => onSelect(occur)}
          >
            <TableGrid.Cell xs={1}>
              <Icon style={{ color: primaryColor, fontSize: 32 }}>
                {occur.icon}
              </Icon>
            </TableGrid.Cell>
            <TableGrid.Title xs={7}>{occur.reason}</TableGrid.Title>
            <TableGrid.Text xs={4}>
              {t("occurrences.dateAt", { date, time: (time || "").trim() })}
            </TableGrid.Text>
          </TableGrid.Row>
        );
      })}
    </TableGrid>
  );
}

OccurrenceTableList.propTypes = {
  occurrences: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  primaryColor: PropTypes.string.isRequired,
  dateLocale: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string.isRequired
};
